export function convertIdToNumber(numericId: string | undefined) {
  if (numericId === undefined) return undefined;

  return !Number.isNaN(parseInt(numericId)) ? parseInt(numericId) : undefined;
}
